<template>
  <div class="list-topics">
    <Tree
      :value="treeData"
      @input="handleItemsChange"
      :indent="30"
      :eachDroppable="eachDroppable"
      triggerClass="icon-drag"
    >
      <template slot-scope="{ node }">
        <v-expansion-panels flat>
          <v-expansion-panel class="expansion-topic">
            <div class="icon-drag cursor-pointer">
              <v-icon class="">mdi-drag</v-icon>
            </div>
            <v-expansion-panel-header disable-icon-rotate>
              <span class="ml-3">{{ $vuetify.lang.t(node.label) }}</span>
              <template v-slot:actions>
                <div class="d-flex justify-end">
                  <v-btn icon @click.stop="$emit('onEdit', node)" class="action-hover">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click.stop="$emit('onRemove', node)">
                        <v-list-item-content>
                          <v-list-item-title>Xóa</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </v-expansion-panel-header>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
    </Tree>
  </div>
</template>
<script>
import 'he-tree-vue/dist/he-tree-vue.css'
import { Tree, Draggable } from 'he-tree-vue'

const MAX_TIER = 2
export default {
  components: {
    Tree: Tree.mixPlugins([Draggable]),
  },
  props: {
    topics: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      treeData: [],
    }
  },
  methods: {
    eachDroppable(path, _, store) {
      const dragNode = store.dragNode
      if (Array.isArray(dragNode.children) && dragNode.children.length) return path.length < 1
      return path.length <= MAX_TIER - 1
    },
    async handleItemsChange(treeData) {
      await this.$utils.delay(500)
      this.treeData = treeData.map((data) => {
        data = {
          ...data,
          parentId: null,
        }
        if (Array.isArray(data.children) && data.children.length) {
          data.children = data.children.map((c) => ({ ...c, parentId: data.id }))
        }
        return data
      })
      this.$emit('onUpdateItems', this.treeData)
    },
    getData() {
      return this.treeData
    },
  },
  watch: {
    items: {
      handler(val) {
        this.treeData = val
      },
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .tree-node {
    border: 0;
    padding: 0;
  }
}

.icon-drag {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  transform: translate(-15%, 15%);
  .v-icon {
    padding: 12px 0 0 12px;
  }
}
::v-deep .expansion-topic {
  > .v-expansion-panel-header {
    &--active {
      min-height: 48px;
    }
  }
  &.v-expansion-panel {
    border: 1px solid rgb(227, 227, 227);
  }
}
</style>
